import React from "react";
import Schedule_img from "styles/common/img/myplan/icon_close2.png";
import Schedule_img2 from "styles/common/img/myplan/icon_reset2.png";
import Schedule_img3 from "styles/common/img/mypage/ico-close-tmtbl.png";

// 호출형식
// <Header handleClickClose={handleClickClose} handleClickReset={handleClickReset} title={"우리학교 교과서 설정"} />
const Header = (props) => {
    const { handleClickClose, handleClickReset, title } = props;

    return (
        <div className={"Schedule_header " + (props.className ? props.className : "")}>
            <a className="close" onClick={handleClickClose}>
                {title === "표준 시간표 강좌 변경" ? (
                    <img src={Schedule_img3} alt="취소" />
                ) : (
                    <img src={Schedule_img} alt="닫기" />
                )}
            </a>
            <h1>{title}</h1>
            {handleClickReset ? (
                <a className="reset" onClick={handleClickReset}>
                    {title !== "표준 시간표 강좌 변경" && <img src={Schedule_img2} alt="설정 초기화" />}
                    설정 초기화
                </a>
            ) : (
                ""
            )}
        </div>
    );
};

export default Header;
